import { createApp } from 'vue'
import  dialog from './index.vue'

import store from '@/store'
import tips from '@/common/tips'
import axios from '@/common/axios'
import tools from '@/common/tool'
import urls from '@/common/urls'
import config from '@/common/config'
import { LocaleInjectionKey, localeProviderMaker } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
function CustomDialog(data) {
  return new Promise((resolve, reject) => {
    // 实例化组件，createApp第二个参数是props
    const myDiaLog = createApp(dialog, {
      data,
      doComfirm: () => {
        // console.log(2222)
        unmount()
        resolve()
      },
      doCancel: (status=false) => {
        // console.log(333,status)
        unmount()
        reject(status)
      }
    })
    
    const opts = { locale: zhCn };
    const localeProvides = localeProviderMaker(opts.locale);
    myDiaLog.provide(LocaleInjectionKey, localeProvides);
    // 卸载组件
    myDiaLog.config.globalProperties.$tips = tips
    myDiaLog.config.globalProperties.$axios = axios
    myDiaLog.config.globalProperties.$config = config
    myDiaLog.config.globalProperties.$urls = urls
    myDiaLog.config.globalProperties.$tools = tools
    myDiaLog.use(store)
    const unmount = () => {
      myDiaLog.unmount()
      document.body.removeChild(parentNode)
    }
    // 创建一个挂载容器
    const parentNode = document.createElement('div')
    document.body.appendChild(parentNode)
    // 挂载组件
    myDiaLog.mount(parentNode)
  })
}

export default CustomDialog